import i18next from 'i18next';
import { TabType } from '@wildberries/ui-kit';
import {
  ALL_SUPPLIES_PAGE_NODE,
  DRAFTS_PAGE_NODE,
  SUPPLIES_PLAN_PAGE_NODE,
  WAREHOUSES_LIMITS_PAGE_NODE,
  TRANSIT_REPORT_NODE,
} from '@/_constants/page-node';
import { MAIN_PAGE_TRANSLATIONS } from '@/pages/supplies-management/_constants/translations';

export const SUPPLIES_ALL_TABS: Array<TabType> = [
  {
    id: '1',
    link: ALL_SUPPLIES_PAGE_NODE,
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.allSuppliesTitle),
  },
  {
    id: '2',
    link: DRAFTS_PAGE_NODE,
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.draftsTitle),
  },
  {
    id: '3',
    link: SUPPLIES_PLAN_PAGE_NODE,
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.suppliesPlanTitle),
  },
  {
    id: '4',
    link: WAREHOUSES_LIMITS_PAGE_NODE,
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.warehousesCoefficientsTitle),
  },
  {
    id: '5',
    link: TRANSIT_REPORT_NODE,
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.transitReportTitle),
  },
];

export const SUPPLIES_TAB: Array<TabType> = [
  {
    id: '1',
    link: ALL_SUPPLIES_PAGE_NODE,
    title: i18next.t(MAIN_PAGE_TRANSLATIONS.allSuppliesTitle),
  },
];
